import { NumberFormatter, Text } from "@mantine/core";
import { useLanguage } from "../../../../../../stores/LanguageStore";

const ContactsResponse = ({ item }) => {
  const lang = useLanguage((s) => s.language);
  const fields = [
    "contacts_added",
    "contacts_updated",
    "contacts_deleted",
    "contacts_ignored",
    "contacts_with_ignored_fields",
    "data_already_existing",
    "data_ignored",
    "data_imported",
  ];

  if (item?.import_contacts_response) {
    return fields.map((field) =>
      item.import_contacts_response[field] ? (
        <Text key={field}>
          <b style={{ marginRight: 4 }}>
            <NumberFormatter
              value={item.import_contacts_response[field]}
              thousandSeparator=" "
            />
          </b>
          {lang.contact_lists.jobs.completed?.[field]}
        </Text>
      ) : (
        ""
      )
    );
  }
  return fields.map((field) =>
    item?.[field] !== undefined ? (
      <Text key={field}>
        <b style={{ marginRight: 4 }}>
          <NumberFormatter
            value={item?.[field]}
            thousandSeparator=" "
          />
        </b>
        {lang.contact_lists.jobs.completed?.[field]}
      </Text>
    ) : (
      ""
    )
  );
};

export default ContactsResponse;
